import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { Area } from '../clases/area';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AreaService {

  private area$: BehaviorSubject<Area[]> = new BehaviorSubject<Area[]>([]);
  constructor(
    private _http: HttpClient
   ) { }

  saveArea(data: any) {
    const url = environment.URL_BASE + "AreaAuthorization/CrearArea";
    return this._http.post(url, data);
  }

  listarAreasCmb(data: any) {
    const url = environment.URL_BASE + "AreaAuthorization/ListarAreasBYEmpresa";
    return this._http.post(url, data);
  }

  listarAreaEmpresa(data: any){
    const url = environment.URL_BASE + "AreaAuthorization/ListarAreasEmpresa";
    return this._http.post(url, data);
  }

  listAreasSubAreas(data: any) {
    const url = environment.URL_BASE + "Area/ObtenerAreas";
    var hola = this._http.post(url, data).pipe(
      map( (res: any) => {
        this.area$.next(res.list);
        return res;
      })
    )

    return hola
  }

  obtenerAreaSubArea(data: any) {
    const url = environment.URL_BASE + "Area/ObtenerArea";
    return this._http.post(url, data);
  }

  getAreas(){

    return this.area$;
  }

  getAreaId(id: number | string){

    return this.getAreas().pipe(
      map( listarArea => listarArea.find(area => area.idArea == id))
    );
  }

}
